
import { ComboService } from "@/services/ComboService";
import { Constantes } from "@/Util/Constantes";
import { AutoCompleteTemplate, ComboEnum, Utilidades } from "@/Util/Utilidades";
import Vue from "vue";

export default Vue.extend({
  name: "AutocompleteSerie",
  components: {
    EditarSerie: () => import("@/views/Administracion/Serie/EditarSerie.vue"),
  },
  props: {
    label: String,
    tag: String,
    rules: Array,
    disabled: Boolean,
    reverse: Boolean,
    hint: {
      type: [String, Number],
      default: "",
    },
    clase: String,
    placeholder: String,
    itemText: [String, Function],
    itemValue: String,
    multiple: Boolean,
    smallChips: Boolean,
    persistent_hint: Boolean,
    returnObject: Boolean,
    width: String,
    value: [String, Number, Array, Object],
    empresa_defecto: Boolean,
  },
  data: function () {
    return {
      valor: null,
      deshabilitado: false,
      series: new Array<Object>() as Array<AutoCompleteTemplate>,
      loading: false as boolean,
      dialog: false as boolean,
    };
  },
  watch: {
    valor: {
      immediate: true,
      handler(novoValor) {
        this.$emit("input", novoValor);
      },
    },
    value: {
      immediate: true,
      handler(val) {
        this.valor = val;
      },
    },
    items: {
      immediate: true,
      handler(items) {
        if (items) {
          if (items.length == 1) {
            this.valor = items[0].value;
            this.deshabilitado = true;
          }
        }
      },
    },
  },
  async created() {
    await this.cargarSeries();
  },
  methods: {
    async cargarSeries() {
      this.loading = true;
      this.series = await ComboService.getComboAsync(ComboEnum.TP_SERIE, "1,");

      if (this.series) {
        if (this.series.length == 1) {
          this.valor = this.series[0].value;
          await this.change();
        }
        // this.series.push(new AutoCompleteTemplate("", "button"));
      }
      this.loading = false;
    },
    getWidth() {
      if (!Utilidades.isNullOrUndefinedOrEmpty(this.width)) {
        return "width:" + this.width + " !important";
      } else {
        return "";
      }
    },
    getSinDatos() {
      return Constantes.SIN_DATOS;
    },
    async change() {
      await Utilidades.sleep(50);
      this.$emit("change");
    },
  },
});
